<template>
  <table style="width: 100%;height:100%">
    <!-- <tr>
      <td>
        <center>
          <span class="label">{{ $t('totem.weatherForecast').toUpperCase() }}</span>
        </center>
      </td>
    </tr> -->
    <tr>
      <td>
        <center>
          <div class="meteo-item">
            <table v-if="this.meteoData">
              <tr>
                <td>
                  <v-img
                    :src="this.meteoData.Icono"
                    width="50px"
                    height="auto"
                  />
                </td>
                <td>{{this.meteoData.Max}}ºC</td>
              </tr>
            </table>
          </div>
        </center>
      </td>
    </tr>
  </table>
</template>

<script>
import {
  mapState
} from 'vuex'
import constants from "@/constants"
import api from '@/services/api'
import utils from '@/services/utils'
import axios from 'axios'
export default {
  data () {
    return {
      meteoData: null
    }
  },
  computed: {
    ...mapState('app',['totemMeteoID']),
    sidebarWidth() {
      return constants.totem.sidebar.width + 'px'
    },
    height() {
      return constants.totem.meteo.height + 'px'
    }
  },
  watch: {
    totemMeteoID: {
      handler: function (newValue) {
        this.getData(newValue)
      },
      deep: true
    },
  },
  mounted () {
    api.getItem('enterprises', false, utils.getDomain()).then(response => {
      this.getData(response.MeteoID)
    })
  },
  methods: {
    getData (id) {
      axios.get('https://widgets.dviewcontent.com/Meteo/api/?ID=' + id)
      .then(response => {
        const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        const auxMeteoData = response.data.map(item => {
          const aux = new Date(item.Dia)
          return ({
            Dia: item.Dia,
            sDay: aux.toLocaleDateString(this.$store.state.app.locale, options),
            DayOfWeek: aux.toLocaleDateString(this.$store.state.app.locale, {weekday: 'long'}).toUpperCase(),
            Icono: item.Icono.replace('imagenesmeteo/','imagenesmeteo8/'),
            Km_h: item.Km_h,
            Lugar: item.Lugar,
            Max: item.Max,
            Min: item.Min,
            Temp: `${item.Max}\xB0/${item.Min}\xB0`
          })
        })
        if (auxMeteoData.length > 0) this.meteoData = auxMeteoData[0]
      })
      .catch(function (error) {
      })
    }
  }
}
</script>

<style scoped>
.meteo {
  position: relative;
  background-color: #000000cc;
  width: var(--sidebar-width);
  height: var(--height);
  z-index: 100;
}
.meteo-item {
  border: 4px solid;
  border-color: rgba(0, 0, 0, 0.208);
  border-radius: 40px;
  width: 80%;
  background-color: rgba(0, 0, 0, 0.208);
  color: white;
  line-height: 0;
  font-size: 30px;
  font-weight: 700;
}
</style>
